module.exports = __webpack_public_path__ + "img/serviceState1.392960c9.webp";